import { useMemo } from 'react';
import { sortCards } from '@/utils/sort';
/**
 * Возвращает отсортированный и подготовленный массив карточек инициативы.
 */
export function useCardsMemo(cards) {
    return useMemo(() => sortCards(cards), [cards]);
}
